import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import User from '../../../models/User';
import PickupOrder from '../../../models/PickupOrder';

import OrdersHeader from './OrdersHeader';

interface CreateOrdersHeaderContainerProps {
  order: PickupOrder;
  user: User;
};

class OrdersHeaderContainer extends Component<CreateOrdersHeaderContainerProps> {

  render() {
  
    return (
      <Fragment>
        { this.props.order.number &&
          <OrdersHeader 
            type={ this.props.order.order_type }
            orderNumber={ this.props.order.number }
            forwarder={ this.props.user }
          />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    order: state.order
  };
};

export default connect(mapStateToProps)(OrdersHeaderContainer);